import {
  LABOGRUPO_SUCCESS,
  LABOGRUPO_CENTROS,
  LABOGRUPO_LOADING,
  LABOGRUPO_ERROR,
  LABOGRUPO_RESET,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";

/* export const laboGrupo = () => (dispatch) => {
  dispatch({
    type: LABOGRUPO_LOADING,
  });
  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/laboratorio/grupoestudio`)
      .then((res) => {
        dispatch({
          type: LABOGRUPO_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABOGRUPO_ERROR,
          payload: error,
        });
      });
  });
}; */

// IDs de estudios a ocultar del listado de laboratorio
const ESTUDIOS_OCULTOS_IDS = [1270, 1297]; // CHEQUEO SEXUAL ITS - HOMBRES/MUJERES

export const laboGrupo = () => (dispatch) => {
  dispatch({
    type: LABOGRUPO_LOADING,
  });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`lis/laboratorio/grupoestudio`)
      .then((res) => {
        // Filtrar estudios ocultos
        const dataFiltrada = Array.isArray(res.data)
          ? res.data.filter((estudio) => !ESTUDIOS_OCULTOS_IDS.includes(estudio.id))
          : res.data;

        dispatch({
          type: LABOGRUPO_SUCCESS,
          payload: dataFiltrada,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABOGRUPO_ERROR,
          payload: error,
        });
      });
  });
};

export const wsGetLaboCentros = (nextStep) => (dispatch) => {
  dispatch({
    type: LABOGRUPO_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/lis/laboratorio/centros`)
      .then((res) => {
        dispatch({
          type: LABOGRUPO_CENTROS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABOGRUPO_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, error);
      });
  });
};
// export const wsGetLaboCentros = (nextStep) => (dispatch) => {
//   dispatch({
//     type: LABOGRUPO_LOADING,
//   });

//   axiosInstance().then((respuesta) => {
//     respuesta
//       .get(`/laboratorio/centros`)
//       .then((res) => {
//         dispatch({
//           type: LABOGRUPO_CENTROS,
//           payload: res.data,
//         });
//         if (nextStep) nextStep(true, res.data);
//       })
//       .catch((err) => {
//         let error = {
//           detail: err.response
//             ? err.response.data
//             : "Error al contactar el server.",
//         };

//         dispatch({
//           type: LABOGRUPO_ERROR,
//           payload: error,
//         });
//         if (nextStep) nextStep(false, error);
//       });
//   });
// };

export const resetLaboGrupo = () => (dispatch) => {
  dispatch({
    type: LABOGRUPO_RESET,
  });
};
